import React, { Component } from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Input, InputGroup, InputGroupAddon } from 'reactstrap';
import { confirmAlert } from 'react-confirm-alert'
import 'react-confirm-alert/src/react-confirm-alert.css'
import { codeBankRef, userRef } from '../../config'
import DatePicker from 'react-datepicker'
import moment from 'moment'
import 'react-datepicker/dist/react-datepicker.css'
import Alert from 'react-s-alert'
import 'react-s-alert/dist/s-alert-default.css'
import 'react-s-alert/dist/s-alert-css-effects/scale.css'

export default class CodeBank extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      codes: [],
      codebanks:[],
      userId:"",
      modal: false,
      linkedUsers:[],
      updated:false,
      readOnly:false,
      saveCode:false,
      email:"",
      startDate: moment()
    }
    this.handleCodeChange = this.handleCodeChange.bind(this)
    // this.saveCode = this.saveCode.bind(this)
  }

  static defaultProps = {
      buttonLabel: "Request Access"
  }

  getLinkedUsers = userId => {
    let query = userRef.child(userId).child("codebank");
    // alert("getLinkedUsers")
    query.once('value', s => {
      console.log()
      if (s.exists()) {
        let codes = this.state.codes
        Object.keys(s.val()).map(k => codes.push({ ...s.val()[k], firebaseUrl: k, readOnly:true }))
        this.setState({
          loading: false,
          // codes: [...this.state.codes, { ...s.val(), firebaseUrl: s.key }]
          codes: codes
        })
        return
      }else {
        this.setState({
          loading: false
        })
      }
    })
  }

  getCodeBanks = userId => {
    let query = userRef.child(userId).child("codebank");

    query.on('child_added', s => {
      this.setState({
        // codes: Object.assign(this.state.codes, s.val(), { firebaseUrl: s.key })
        codes: [...this.state.codes, { ...s.val(), firebaseUrl: s.key }],
        loading: false,
        saveCode:false
      })
    })

    query.once('value', s => {
      if (s.exists()) {
        this.setState({
          loading: false,
          codes: Object.keys(s.val()).map(k => ({ ...s.val()[k], firebaseUrl: k }))
        })
        return
      }else {
        this.setState({
          loading: false
        })
      }
    })

    query.on('child_removed', s => {
      this.setState({
        codes: this.state.codes.filter(code => code.firebaseUrl !== s.key),
        updated:true,
        saveCode:false
      })
    })
  }

  componentDidMount() {
    console.log('code bank did mount')
    if(localStorage.userType === "admin"){
      console.log('code bank did mount')
      //setup our listeners for codes added and codes removed
      //and obviously save all current codes in state
      codeBankRef.once('value', s => {
        console.log(s.val())
        if (s.exists()) {
          console.log('snap exists', s.val())
          this.setState({
            loading: false,
            codes: Object.keys(s.val()).map(k => ({ ...s.val()[k], firebaseUrl: k }))
          })
          return
        }
        else {
          this.setState({
            loading: false
          })
        }
      })

      codeBankRef.on('child_added', s => {
        this.setState({
          codes: [...this.state.codes, { ...s.val(), firebaseUrl: s.key }]
        })
      })

      codeBankRef.on('child_removed', s => {
        this.setState({
          codes: this.state.codes.filter(code => code.firebaseUrl !== s.key)
        })
      })

      // codeBankRef.on('child_changed', s => {
      //   this.setState({
      //     codes: [...this.state.codes, { ...s.val(), firebaseUrl: s.key }]
      //   })
      // })
    }else{
      let query = userRef.orderByChild("email").equalTo(localStorage.email);
      let linkedUsers = [];
      query.once('value', snapshot => {
        Object.keys(snapshot.val()).map(k => {
          this.setState({userId:k})
          if(snapshot.child(k).hasChild("LinkedUsers")) {
            let q = userRef.child(k).child("LinkedUsers").orderByChild("status").equalTo("approved")
            q.once("value", snap => {
              if (snap.exists()) {
                snap.forEach(snapshot => {
                  linkedUsers.push(snapshot.val().email)
                })
              }
            }).then(() => {
              if(linkedUsers.length > 0) {
                linkedUsers.map(item => {
                  userRef.orderByChild("email").equalTo(item)
                  .once('value', snapshot => {
                    if (snapshot.exists()) {
                      let key = Object.keys(snapshot.val()).toString()
                      this.getLinkedUsers(key)
                    }
                  })
                })
              }
            })
          }
        })
      }).then(() => {
          this.getCodeBanks(this.state.userId)
      })
    }
  }

  componentWillUnmount() {
    userRef.off()
    codeBankRef.off()
    // query.off()
  }

  removeCode = (code) => {
    if(localStorage.userType === "admin"){
        if(code.eventName === "placeholder" && code.password === "placeholder"){
          let array = this.state.codes
          let index = array.indexOf(code)
          array.splice(index, 1);
          this.setState({codes: array });
        }else{
        confirmAlert({
          title: 'Confirm to Delete',                        // Title dialog
          message: 'Are you sure to want to delete '+code.eventName,               // Message dialog
          // childrenElement: () => <div>Custom UI</div>,       // Custom UI or Component
          confirmLabel: 'Confirm',                           // Text button confirm
          cancelLabel: 'Cancel',                             // Text button cancel
          onConfirm: () => {
            if(code.firebaseUrl === null){
              let array = this.state.codes
              let index = this.state.codes.indexOf(code)
              array.splice(index, 1);
              this.setState({
                codes: array, 
                editing: false
              });
            }else{
              codeBankRef.child(code.firebaseUrl).remove()
            }
          }
          // onCancel: () => alert('Action after Cancel'),      // Action after Cancel
        })
      }
    }else{
      let query = userRef.child(this.state.userId).child("codebank");
      if(code.eventName === "placeholder" && code.password === "placeholder"){
          let array = this.state.codes
          let index = array.indexOf(code)
          array.splice(index, 1);
          this.setState({codes: array });
      }else{
        this.setState({
          saveCode:true
        })
        confirmAlert({
          title: 'Confirm to Delete',                        // Title dialog
          message: 'Are you sure to want to delete '+code.eventName,               // Message dialog
          // childrenElement: () => <div>Custom UI</div>,       // Custom UI or Component
          confirmLabel: 'Confirm',                           // Text button confirm
          cancelLabel: 'Cancel',                             // Text button cancel
          onConfirm: () => {
            if(code.firebaseUrl === null){
              let array = this.state.codes
              let index = this.state.codes.indexOf(code)
              array.splice(index, 1);
              this.setState({
                codes: array, 
                editing: false
              });
            }else{
              query.child(code.firebaseUrl).remove() 
            }
          }
          // onConfirm: () => codeBankRef.child(code.firebaseUrl).remove()    // Action after Confirm
          // onCancel: () => alert('Action after Cancel'),      // Action after Cancel
        })
      } 
    }
  }

  handleCodeChange(newVal, itemIndex, key) {
    let code = this.state.codes[itemIndex]
    if (key === 'expirationDate') {
      newVal = moment(newVal).format()
    }
    let newCode = Object.assign(code, { [key]: newVal })
    console.log('got new code', newCode)
    let oldCodes = this.state.codes
    // console.log(oldCodes[itemIndex])
    oldCodes[itemIndex] = newCode
    console.log(newCode)
    // console.log(oldCodes)
    this.setState({
      editing: true,
      editedCode: newCode,
      codeIndex: itemIndex,
      codes: oldCodes

    })
  }

  saveCode = e => {
    e.preventDefault()
    const { firebaseUrl } = this.state.editedCode
    if(localStorage.userType === "admin"){
      if (firebaseUrl === null) {
        codeBankRef.push(this.state.editedCode, () => {
          this.setState({
            editedCode: null,
            editing: false,
            codeIndex: null,
            codes: [...this.state.codes.filter((code, index) => this.state.codeIndex !== index)]
          })
        })
      }else{
        let object = this.state.editedCode;
        let codeIndex = this.state.codeIndex;
        let query = codeBankRef.child(object.firebaseUrl);
        alert(JSON.stringify(object)) 
        this.setState({
          editedCode: null,
          editing: false
        })
        query.once("value", function(snapshot) {
          snapshot.ref.update({ eventName: object.eventName ,
                                expirationDate:object.expirationDate, 
                                password: object.password }, () =>{
                                  console.log("record updated")
                                })
        });
      }
    }else{
    // added new query object for refrence to u codebank for each user on basis of uid
    let query = userRef.child(this.state.userId).child("codebank");
    this.setState({
      saveCode:true
    })
    if (firebaseUrl === null) {
      // codeBankRef.push(this.state.editedCode, () => {
      //   this.setState({
      //     editedCode: null,
      //     editing: false,
      //     codeIndex: null,
      //     codes: [...this.state.codes.filter((code, index) => this.state.codeIndex !== index)]
      //   })
      // })
      query.push(this.state.editedCode, () => {
        this.setState({
          editedCode: null,
          editing: false,
          codeIndex: null,
          codes: [...this.state.codes.filter((code, index) => this.state.codeIndex !== index)]
        })
      })
    }else{
      let object = this.state.editedCode;
      let codeIndex = this.state.codeIndex;
      // let adminCodebankQuery = codeBankRef.child(object.firebaseUrl);
      this.setState({
        editedCode: null,
        editing: false,
        updated:true
      })
      // adminCodebankQuery.child(object.firebaseUrl).once("value", function(snapshot) {
      //   snapshot.ref.update({ eventName: object.eventName ,
      //                         expirationDate:object.expirationDate, 
      //                         password: object.password }, () =>{
      //                           console.log("record updated")
      //                         })

        query.child(object.firebaseUrl).once("value", function(snapshot) {
          snapshot.ref.update({ eventName: object.eventName ,
                                expirationDate:object.expirationDate, 
                                password: object.password }, () =>{
                                  console.log("record updated")
                                })
        });
      }
    }
  }

  addNewCodeBank() {
    this.setState({
      codes: [...this.state.codes, { eventName: 'placeholder', password: 'placeholder', 'expirationDate': moment.now(), 'firebaseUrl': null }]
    })
    setTimeout(() => {
      window.scrollTo(0, document.body.scrollHeight || document.documentElement.scrollHeight);
    }, 10);
  }

  handleItemChange = e => {
    console.log(e.target.value)
    this.setState({
      email:e.target.value
    })
  }

  toggle = () => {
    this.setState({
      modal: !this.state.modal
    });
  }

  saveEmail = () => {
    let promise = new Promise((resolve, reject) => { 
      let list = [];
      let emails = this.state.email.split(',')
      emails.map(item => {
        userRef.child(this.state.userId).once("value", snapshot => {
            // if(snapshot.child(snapshot.key).hasChild("LinkedUsers")){
              userRef.child(this.state.userId).child("LinkedUsers").orderByChild("email").equalTo(item)
              .once('value', snap => {
                if(snap.exists()){
                  Alert.error(`${item} exists`, {
                      position: 'top-right',
                      effect: 'scale',
                      timeout: 5000,
                      offset:'0'
                  });
                  reject(`${item} exists`)
                }else{
                  Alert.success(`${item} Sent for request to link`, {
                      position: 'top-right',
                      effect: 'scale',
                      timeout: 5000,
                      offset:'0'
                  });
                userRef.child(this.state.userId).child("LinkedUsers").push(Object.assign({}, {email:item, verify:false, status:"pending" }))
                  resolve(`${item} Sent for request`)
                }
              })
            // }
          })
      })
    })
    promise.then(value => {
      this.setState({
        modal: !this.state.modal
      });      
    }, reason => {
      this.setState({
        modal: !this.state.modal
      });            
    })
  }

  render() {
    let codeStyle = {
      background: '#fff'
    }
    let addNewCodeStyle = {
      position: 'relative'
    }

    console.log("codes:")
    console.log(this.state.codes)

    if (this.state.loading) {
      return (
        <div className='animated fade-in'>
          <h4 className='text-center'> Loading codes...</h4>
        </div>
      )
    }
    
    const buildModalHeading = () => {
      if (this.state.editing === true) {
        return (
          <div className='modal-title'> <i className='fa fa-thumbs-up'> </i> Recommend this item</div>
        )
      }
    }

    let requestButton = () => {}
    if(localStorage.userType !== "admin"){
      requestButton = () => { 
        return(
          <Button color="primary" onClick={this.toggle}>{this.props.buttonLabel}</Button>
        )
      }
    }

    const buildModalBody = () => {
      return (
        <form>
          <div className="form-group">
            <InputGroup>
              <InputGroupAddon>@</InputGroupAddon>
              <Input type="email" name="email" id="email" className="form-control" onChange={this.handleItemChange} placeholder="Email address separated by comma" />
            </InputGroup>
          </div>
        </form>
      )
    }

    let codeNodes = this.state.codes.map((code, codeIndex) => {
      if(code.readOnly){
        return (
          <tr key={codeIndex}>
            <td> <input className='form-control' value={`${code.eventName}`} style={codeStyle} readOnly/></td>
            <td> <input className='form-control' value={`${code.password}`} style={codeStyle} readOnly/></td>
            <td><div style={addNewCodeStyle}><DatePicker className='form-control' selected={moment(code.expirationDate)} readOnly/></div></td>
            <td></td>
          </tr>
        )
      }else{
        return (
          <tr key={codeIndex}>
            <td> <input className='form-control' value={`${code.eventName}`} style={codeStyle} onChange={(e) => this.handleCodeChange(e.target.value, codeIndex, 'eventName')} /></td>
            <td> <input className='form-control' value={`${code.password}`} style={codeStyle} onChange={(e) => this.handleCodeChange(e.target.value, codeIndex, 'password')} /></td>
            <td><div style={addNewCodeStyle}><DatePicker className='form-control' selected={moment(code.expirationDate)} onChange={(e) => this.handleCodeChange(e, codeIndex, 'expirationDate')} /></div></td>
            <td> <button className='btn btn-danger btn-xs' onClick={(e) => this.removeCode(code)}> <i className="fa fa-remove"></i> </button> </td>
          </tr>
        )
      }
    })
    return (
      <div className='animated fade-in'>
        <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className}>
          <ModalHeader toggle={this.toggle}>Send request to access</ModalHeader>
          <ModalBody>
            {buildModalBody()}
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.saveEmail}>Send</Button>{' '}
            <Button color="secondary" onClick={this.toggle}>Cancel</Button>
          </ModalFooter>
        </Modal>
        <div>
          <div>
            <div className="text-right form-group">
              {requestButton()}
              <button className='btn btn-primary' onClick={()=>this.addNewCodeBank()}> Add New Code</button>
              {this.state.editing ? <button className='btn btn-success' onClick={this.saveCode}> Done</button> : ''}
            </div>
            <div className="table-responsive data-view">
              <table className='table table-condensed'>
                <thead>
                  <tr>
                    <th> Event Name </th>
                    <th> password </th>
                    <th> Expiration date </th>
                    <th> Remove Code </th>
                  </tr>
                </thead>
                <tbody>
                  {codeNodes}
                </tbody>
              </table>
              </div>
          </div>
        </div>
        <Alert stack={{limit: 3}} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/CodeBank/CodeBank.js